module.exports = __webpack_public_path__ + "static/social-share-0b1597688f152d7826cb7ddd6b3dcaf2.jpg";